var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.493,
    height: 17.922,
    viewBox: "0 0 10.493 17.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "angle-small-left_1_",
    "data-name": "angle-small-left (1)",
    d: "M13.382,13.2a.554.554,0,0,0,0-.785L8.3,7.338a1.662,1.662,0,0,1,2.35-2.351l5.082,5.082a3.884,3.884,0,0,1,0,5.485L10.65,20.635A1.662,1.662,0,0,1,8.3,18.284Z",
    transform: "translate(-7.023 -3.85)",
    fill: "#adadad",
    stroke: "#fff",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.2f9edfcf300f4369e2a799e7da69f2a1.svg";
export { ForwardRef as ReactComponent };